// extracted by mini-css-extract-plugin
export default {"text":"CompanyNameConsentModal_text__S2U51"};